//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: {
    title: {
      type: String,
      required: true,
    },
    background: {
      type: String,
    },
    info: {
      type: Object,
      default: () => ({}),
    },
    isShop: {
      type: Boolean,
      default: false,
    },
  },
};
